<script>
   export let image = '';
   export let movieId = '';
   export let clickable = false;

   const noImage = '/images/no-movie-image-t.png';
</script>

<div>
   {#if clickable}
      <a href="/movie/{movieId}">
         <img
            class="clickable"
            src={image ? image : noImage}
            alt="moviethumb" />
      </a>
   {:else}<img src={image ? image : noImage} alt="moviethumb" />{/if}
</div>

<style>
   div {
      height: 100%;
   }
   img {
      width: 100%;
      height: 100%;
      transition: all 0.3s;
      object-fit: cover;
      border-radius: 18px;
   }
   img:hover {
      opacity: 0.76;
   }
   .clickable {
      cursor: pointer;
   }
</style>
